export enum Goals {
	PROMPTUARY_CREATED = 'promptuary_created',
}
